import React from 'react';

const ScreenHeading = (props) => {
	return <h1 className='screen-heading'>{props.heading}</h1>;
};

export default ScreenHeading;
